export default __webpack_public_path__ + "static/media/document.8c8be60c.svg";